import { observer } from 'mobx-react-lite'
import './index.scss'
import XImg from '@assets/svg/x.svg'
import { Context } from '@/index'
import { useContext } from 'react'
import { changeTaskStatus as changeTaskStatusApi } from '@api/task-api';

const SubmitTaskModal = observer(({taskId, callGetTask}) => {
    const { modal } = useContext(Context);

    const submitTask = () => {
        const object = {
            task_status: 'submission'
        }
        changeTaskStatusApi(taskId, object)
        .then(() => {
            callGetTask();
            modal.closeModal();
        })
        .catch((error) => {
            console.log(error);
        })
    }

    return (
        <div className="submit-task-modal">
            <div className="header-modal">
                İşi yoxlama üçün təqdim etmə
                <div className="x-block" onClick={() => modal.closeModal()}>
                    <img src={XImg} className="x"/>
                </div>
            </div>
            <div className="description">
                Sifarişin bütün bəndlərini texniki tapşırığa uyğun olaraq tam yerinə yetirdiyinizə əmin olun.
            </div>
            <div className="row">
                <div className="col-md-6">
                    <button type="button" className="my-button2" onClick={() => modal.closeModal()}>Bağla</button>
                </div>
                <div className="col-md-6">
                    <button type="button" className="my-button" onClick={submitTask}>İşi təqdim et</button>
                </div>
            </div>
            
        </div>
    )
})

export { SubmitTaskModal }